export const getMinutesInMiliseconds = ({ minutes }: { minutes: number }) => {
  return 1000 * 60 * minutes;
};
